var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { BadgeStyledComponent } from "./BadgeStyledComponent";
export const PickersDayStyledBadge = (_a) => {
    var { day, invisible, children } = _a, rest = __rest(_a, ["day", "invisible", "children"]);
    return (_createElement(BadgeStyledComponent, Object.assign({}, rest, { key: day.toString(), anchorOrigin: { vertical: "bottom", horizontal: "right" }, overlap: "circular", variant: "dot", invisible: invisible, badgeContent: !invisible ? "" : undefined }), children));
};
